import * as a from "react";
import k from "./chunk997.js";
import w from "./chunk946.js";
import E from "./chunk1165.js";
function D(l = {}) {
  const {
    autoHideDuration: s = null,
    disableWindowBlurListener: m = !1,
    onClose: o,
    open: r,
    resumeHideDuration: f
  } = l, i = k();
  a.useEffect(() => {
    if (!r)
      return;
    function e(n) {
      n.defaultPrevented || n.key === "Escape" && (o == null || o(n, "escapeKeyDown"));
    }
    return document.addEventListener("keydown", e), () => {
      document.removeEventListener("keydown", e);
    };
  }, [r, o]);
  const v = w((e, n) => {
    o == null || o(e, n);
  }), d = w((e) => {
    !o || e == null || i.start(e, () => {
      v(null, "timeout");
    });
  });
  a.useEffect(() => (r && d(s), i.clear), [r, s, d, i]);
  const p = (e) => {
    o == null || o(e, "clickaway");
  }, u = i.clear, c = a.useCallback(() => {
    s != null && d(f ?? s * 0.5);
  }, [s, f, d]), L = (e) => (n) => {
    const t = e.onBlur;
    t == null || t(n), c();
  }, y = (e) => (n) => {
    const t = e.onFocus;
    t == null || t(n), u();
  }, H = (e) => (n) => {
    const t = e.onMouseEnter;
    t == null || t(n), u();
  }, h = (e) => (n) => {
    const t = e.onMouseLeave;
    t == null || t(n), c();
  };
  return a.useEffect(() => {
    if (!m && r)
      return window.addEventListener("focus", c), window.addEventListener("blur", u), () => {
        window.removeEventListener("focus", c), window.removeEventListener("blur", u);
      };
  }, [m, r, c, u]), {
    getRootProps: (e = {}) => {
      const n = {
        ...E(l),
        ...E(e)
      };
      return {
        // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
        // See https://github.com/mui/material-ui/issues/29080
        role: "presentation",
        ...e,
        ...n,
        onBlur: L(n),
        onFocus: y(n),
        onMouseEnter: H(n),
        onMouseLeave: h(n)
      };
    },
    onClickAway: p
  };
}
export {
  D as default
};
